module.exports = __webpack_public_path__ + "static/img/6596_phase_function_Paper_PointsHejduk_Prediction.3cd1654.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6596_phase_function_Paper_PointsHejduk_Prediction.png
// module id = CPOX
// module chunks = 0